import { css } from '@emotion/react';
import styled from '@emotion/styled';
export const CARD_MIN_WIDTH = 180;
export const CARD_MAX_WIDTH = 230;
export const CARD_HEIGHT = 88;
export const CARD_GAP = 12;
export const CARD_PADDING = 8;
export const CARD_PADDING_COMPACT = 1;
export const CARD_CTA_HEIGHT = 25;
export const CARD_BORDER_RADIUS = 6;
export const Wrapper = styled.div `
  position: relative;
  transform: translateX(0);
`;
/**
 * Cards wrapper is used to wrap the cards and make them scrollable.
 * There are 3 ways to render cards:
 *  - All cards are centered as a group because they are all possibly visible
 *  - First card starts centered (some other cards wont fit)
 *  - First card starts left aligned (some other cards wont fit)
 */
export const CardsWrapper = styled.div `
  display: flex;
  overflow-y: visible;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;

  gap: ${CARD_GAP}px;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ allCardsCentered }) => allCardsCentered &&
    css `
      justify-content: center;
    `}

  ${({ firstCardCentered, cardSize, padding }) => firstCardCentered
    ? css `
          & section:first-of-type {
            padding-inline-start: calc((100% - ${cardSize}px) / 2);
          }

          & section:last-of-type {
            padding-inline-end: calc((100% - ${cardSize}px) / 2);
          }
        `
    : css `
          & section:first-of-type {
            padding-inline-start: ${padding || CARD_GAP}px;
          }
          & section:last-of-type {
            padding-inline-end: ${padding || CARD_GAP}px;
          }
        `}
`;
export const CardWrapper = styled.section `
  scroll-snap-align: center;
`;
